import React, { useContext } from 'react';
import type { FlowAction } from '~/graphql/types';
import { reportAndThrow } from '~/util/reportAndThrow';

type ActionContextType = {
  actionId: string;
  actionType: FlowAction;
};

export const ActionContext = React.createContext<ActionContextType | null>(
  null,
);

const useActionContext = (): ActionContextType => {
  const context = useContext(ActionContext);

  if (context === null) {
    return reportAndThrow(
      `Action context should be set before using useActionContext but it wasn't`,
    );
  }

  return context;
};

export default useActionContext;
